// extracted by mini-css-extract-plugin
export var categoryTitle = "product-related-contents-module--categoryTitle--57481";
export var categoryTitleContainer = "product-related-contents-module--categoryTitleContainer--cd182";
export var ckeditorContainer = "product-related-contents-module--ckeditorContainer--32ebb";
export var contactMail = "product-related-contents-module--contactMail--fdd66";
export var containerCategory = "product-related-contents-module--containerCategory--2763e";
export var containerCategoryInfo = "product-related-contents-module--containerCategoryInfo--06fa5";
export var containerContact = "product-related-contents-module--containerContact--6f705";
export var containerContactText = "product-related-contents-module--containerContactText--8e40e";
export var containerContent = "product-related-contents-module--containerContent--ed4b9";
export var containerContentCategory = "product-related-contents-module--containerContentCategory--b1bb4";
export var image = "product-related-contents-module--image--7ea8f";
export var liste = "product-related-contents-module--liste--aed56";
export var nextApp = "product-related-contents-module--nextApp--6d7a1";
export var text = "product-related-contents-module--text--11e57";
export var textContact = "product-related-contents-module--textContact--0817d";
export var titleContact = "product-related-contents-module--titleContact--43b3c";
export var titleStart = "product-related-contents-module--titleStart--8dbf6";